import { useState, useEffect } from 'react';
import { usePOS } from '../context/POSContext';

function ProductGrid() {
  const { products, activeCategory, addToCart, searchQuery } = usePOS();
  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    let filtered = products;

    // Filtrer par catégorie active
    if (activeCategory) {
      filtered = filtered.filter((product) => product.category === activeCategory);
    }

    // Filtrer par recherche
    if (searchQuery) {
      filtered = filtered.filter((product) =>
        product.name
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .includes(searchQuery.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, ''))
      );
    }

    setFilteredProducts(filtered);
    console.log('Produits filtrés:', filtered);
  }, [products, activeCategory, searchQuery]);

  return (
    <div className="max-w-7xl mx-auto px-4">
      {filteredProducts.length === 0 ? (
        <p className="text-center text-gray-500 text-base py-6">
          Aucun produit trouvé.
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-white border border-gray-200 rounded-md shadow-sm"
            >
              <img
              src={`https://snackspongebob.site/backend/api/images/${product.imageUrl}`}
                alt={product.name}
                className="w-full h-32 object-cover rounded-t-md"
              />
              <div className="p-3">
                <h3 className="text-base font-medium text-gray-800">{product.name}</h3>
                <p className="text-sm text-gray-500 line-clamp-1 mt-1">
                  {product.description || 'Sans description'}
                </p>
                <div className="flex justify-between items-center mt-2">
                  <span style={{ color: '#000000' }} className="font-semibold">
                    {product.price.toFixed(2)} (MAD)
                  </span>
                  <button
                    onClick={() => addToCart(product)}
                    style={{ backgroundColor: '#56adb2', color: 'white' }}
                    className="py-1 px-3 rounded-md text-sm transition-colors"
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = '#4a99a5';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = '#56adb2';
                    }}
                  >
                    Ajouter
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <p className="text-sm text-gray-500 mt-4 text-center">
        {filteredProducts.length} produit{filteredProducts.length !== 1 ? 's' : ''} affiché
        {filteredProducts.length !== 1 ? 's' : ''}
      </p>
    </div>
  );
}

export default ProductGrid;
